import { render } from "./AssetView.vue?vue&type=template&id=72c97b09"
import script from "./AssetView.vue?vue&type=script&lang=js"
export * from "./AssetView.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\al-mouj-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__